import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { TaskPriority } from "@components/tasks/TaskPrioritySelect/TaskPriority";
import styles from "./ChatTaskAuditLog.module.scss";

interface Props {
    log: AuditLog;
}

export const ChatTaskPriority: React.FC<Props> = ({ log }) => {
    const newPriority =
        log.diff.find((d) => d.field === "priority")?.after?.value ?? "";
    return (
        <>
            <span className={styles.chatTaskMessage}>
                changed the priority to
            </span>{" "}
            <strong>
                <TaskPriority priority={newPriority} variant="textOnly" />
            </strong>
        </>
    );
};
